var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { ContentNode } from '../entities/content-node';
var cls = classNames('data-grid-cell-long-text');
export var FieldCellLongTextDefaultProps = {
  maxWords: 100
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    user-select: none;\n    \n    /* Match CodeMirror as much as possible */\n    p {\n      line-height: 21px;\n      margin-bottom: 21px;\n    }\n    \n  "], ["\n    user-select: none;\n    \n    /* Match CodeMirror as much as possible */\n    p {\n      line-height: 21px;\n      margin-bottom: 21px;\n    }\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'FieldCellLongText',
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Content: styled(ContentNode)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var FieldCellLongText = function (props) {
  var componentProps = useComponentProps(My.NAME, FieldCellLongTextDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    value = componentProps.value,
    field = componentProps.field,
    rest = __rest(componentProps, ["className", "children", "value", "field"]);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Content, {
    entity: value,
    maxWords: 80,
    showExpandLink: false
  }));
};
FieldCellLongText.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;